import vue from "../../main";

export default class DelegationRateItem {
  constructor() {
    this.id = null;
    this.name = null;
    this.description = null;
    this.users = null;
    this.child_group_names = null;
    this.parent_group_id = null;
    this.parent_group_name = null;
    this.count_rates = null;

    // this.defaults = {
    //     delegation_vehicle_under_900_rate: "0.5214",
    //     delegation_vehicle_above_900_rate: "0.8358",
    //     delegation_vehicle_moped_rate: "0.1383",
    //     delegation_vehicle_motorcycle_rate: "0.2302"
    // };

    // this.rules = {
    //     delegation_vehicle_under_900_rate: [
    //         v => (v != null && v.length > 0) || 'Stawka jest wymagana'
    //     ],
    //     delegation_vehicle_above_900_rate: [
    //         v => (v != null && v.length > 0) || 'Stawka jest wymagana'
    //     ],
    //     delegation_vehicle_moped_rate: [
    //         v => (v != null && v.length > 0) || 'Stawka jest wymagana'
    //     ],
    //     delegation_vehicle_motorcycle_rate: [
    //         v => (v != null && v.length > 0) || 'Stawka jest wymagana'
    //     ]
    // };
  }

  rules() {
    return {
      name: [v => (v != null && v.length > 0) || vue.$t("global.error.required")],
      description: [],
      parent_group_id: []
    };
  }

  load(id) {
    vue.axios.get("settings/delegation-group/get?id=" + id).then(resp => {
      this.id = id;
      this.name = resp.data.name;
      this.description = resp.data.description;
      this.users = resp.data.users;
      this.child_group_names = resp.data.child_group_names;
      this.parent_group_id = resp.data.parent_group_id != null ? resp.data.parent_group_id.toString() : null;
      this.parent_group_name = resp.data.parent_group_name;
      this.count_rates = resp.data.count_rates;
    });
  }

  save() {
    return new Promise((resolve, reject) => {
      vue.axios
        .post("settings/delegation-group/save", {
          id: this.id,
          name: this.name,
          description: this.description,
          parent_group_id: this.parent_group_id
        })
        .then(resp => {
          resolve(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  }
}
